<template>
  <div>
    <div class="input-group">
      <input ref="timeInput" type="time" class="form-control" style="width: 200px;" v-model="time"
        @keyup.enter="submit">

      <span class="input-group-btn">
        <button class="btn btn-sm btn-primary" type="button" @click="submit">Toepassen</button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "DriverStartDate",

  props: {
    groups: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },

  data() {
    return {
      time: null,
    }
  },

  mounted() {
    if (this.groups.length) {
      this.time = this.groups[0].startTime;
    }
  },

  methods: {
    submit() {
      this.$emit('fire', this.time)
    },
  },
}
</script>



// WEBPACK FOOTER //
// resources/js/components/plan/components/DriverStartDate.vue